import { keyframes } from '@emotion/react';
import theme from '@styles/theme';
const scrollLogoAnimation = (logoScrollSpace: number) => keyframes({
  from: {
    transform: 'translateX(0)'
  },
  to: {
    transform: `translateX(-${logoScrollSpace}px)`
  }
});
export default {
  container: (logoScrollSpace: number) => ({
    position: 'relative',
    width: '100%',
    overflow: 'hidden',
    p: ['64px 16px', '64px 16px', '116px 40px', '116px 40px'],
    backgroundColor: theme.rawColors.darkGrey700,
    div: {
      display: 'flex',
      flexDirection: 'row',
      width: `calc( ${logoScrollSpace}px *2)`,
      div: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: `${logoScrollSpace}px`,
        height: '40px',
        transform: 'translate3d(0, 0, 0)',
        animation: `${scrollLogoAnimation(logoScrollSpace)} 20s infinite linear`,
        img: {
          width: 'auto',
          marginRight: '80px'
        }
      }
    }
  })
};